import _ from 'utils/@lodash';
import { forwardRef ,useEffect, useState, createContext } from "react";
import { getCachedData } from "api/Cache";
import { getData } from "api/Entities";
import AuthService, { ConnectionState } from "services/AuthService";
import Main from "views/Main";
import ErrorMessage from "./ErrorMessage";
import { AlertDialog, AppTourNotification } from "components";
import EventsEmitter from "events/EventsEmitter";
import SignalrService, { SignalrStatus } from "services/SignalrService";
import NotificationPanel from 'components/notificationPanel/NotificationPanel';
import { SnackbarProvider } from 'notistack';
import 'components/notificationPanel/style.css';
import { useDispatch, useSelector } from 'react-redux';
import { FoldersActions } from "actions";

//Jumbo theme
import { Header, Sidebar } from 'themes/jumbo/app/_components/layout';
//import { Footer } from 'themes/jumbo/app/_components/layout';
import { defaultLayoutConfig } from 'themes/jumbo/app/_config/layouts';
import { getMenus } from 'themes/jumbo/app/_services';
import { 
    JumboLayout, 
    JumboLayoutProvider,
    JumboDialog,
    JumboDialogProvider,
} from 'themes/jumbo/@jumbo/components';
import { MenuItems } from 'themes/jumbo/@jumbo/types';
import {
	setCachedData
} from "store//cache";
import Joyride, { CallBackProps, EVENTS, BeaconRenderProps } from 'react-joyride';
import tourSteps from 'components/tourSteps'
import { useHistory } from 'react-router-dom';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export const AppContext = createContext({});

export default function Loader() {
    const cachedData = getCachedData();
    const { connectionState } = AuthService;
	const storeCachedData = useSelector((state: any) => state.cache.data);

    const [data, setData] = useState(cachedData);
    const [storeData, setStoreData] = useState<any>(null);
    const [notification, setNotification] = useState({ message: "", type: "" });
    const [error, setError] = useState({ message: "", redirect: false });
    const [runTour, setRunTour] = useState(false);
    const [stepIndex, setStepIndex] = useState(0);
    const [tourActive, setTourActive] = useState(false);
    const history = useHistory();
    const totalSteps = tourSteps.length;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const userData = localStorage.getItem('userSideBarOptions');
    const userSideBarOptions = userData ? JSON.parse(userData) : {};

    isMobile && localStorage.setItem('userSideBarOptions', JSON.stringify({
        ...userSideBarOptions,
        open: false
      })); 
      
    const AppContextValue = {
        runTour,
        setRunTour,
        stepIndex,
        setStepIndex,
        tourActive,
        setTourActive
    }

    const handleCloseAlert = () => {
        setNotification({ message: "", type: "" });
    };
    const dispatch = useDispatch();
    
    const handleCallback = (data: CallBackProps) => {
        const {
            action,
            index,
            step: {
                data: { next, previous },
            },
            type,
        } = data;
        
        const isPreviousAction = action === 'prev';

        if(action === 'close') {
            setRunTour(false);
            setTourActive(false);
            return;
        }

    
        if (type !== EVENTS.STEP_AFTER)  return;
        if (index < totalSteps - 1) {
            setRunTour(false);
            history.push(isPreviousAction && previous ? previous : next);
        }

        if (index === totalSteps - 1) {
                if (isPreviousAction && previous) {
                setRunTour(false);
                history.push(previous);
            } else {
                setRunTour(false);
                setTourActive(false);
                setStepIndex(0);
            }
        }
    };

    const pulse = keyframes`
        0% {
            transform: scale(1);
        }

        55% {
            background-color: rgba(61, 171, 230, 0.9);
            transform: scale(1.6);
        }
    `;

    const BeaconButton = styled.button`
        animation: ${pulse} 1s ease-in-out infinite;
        background-color: rgba(61, 171, 230, 0.6);
        border: 0;
        border-radius: 50%;
        display: inline-block;
        height: 1rem;
        width: 1rem;
    `;

    const BeaconComponent = forwardRef<HTMLButtonElement, BeaconRenderProps>((props, ref) => {
        return <BeaconButton ref={ref} {...props} />;
    });

    useEffect(() => {
        switch (connectionState) {
            case ConnectionState.CONNECTED:
                if (!data.error && !data.loaded) {
                    getData().then((result: any) => {
                        setData(result);
                        //dispatch(setCachedData({ data: JSON.parse(JSON.stringify(result)) }));
                    });
                }
                break;
            case ConnectionState.ERROR:
                setError({ message: AuthService.connectionError, redirect: true });
                break;
        }
    }, [data, connectionState]);

    useEffect(() => {
        const data = getCachedData();
        const _data = JSON.parse(JSON.stringify(storeCachedData));
        //if (_.isEqual(storeCachedData, data)) return;
        
        const updatedData = {
            ...data, 
            ..._data
        };
       FoldersActions.setCachedData(updatedData);
    }, [storeCachedData]);

    useEffect(() => {
        const handleMessage = (msg: any) => {
            setNotification(msg);
        };
        const handleCritical = (error: any) => {
            setError(error);
        };
        const dataUpdate = (data: any) => {
            setData(data);
        };
        const reloadData = (data: any) => {
            getData(true).then((result: any) => {
                const data = JSON.parse(JSON.stringify(result));
                //const storeData = _.pick(storeCachedData, Object.keys(data));
                //if (_.isEqual(storeData, data)) return;
                setData(result);
                dispatch(setCachedData({ data }));
            });
        };
        const changeTab = () => {
            setError({ message: "", redirect: false });
        };
        const cacheUpdate = () => {
            const _data = getCachedData();
            const data = JSON.parse(JSON.stringify(_data));
            /*const storeData = _.pick(storeCachedData, Object.keys(data));
            if (_.isEqual(storeData, data)) {
                console.log(storeData, data, '..................................storeData, data.............................')
                return;
            }*/
            dispatch(setCachedData({ data }));
        };
        EventsEmitter.on("showMessage", handleMessage);
        EventsEmitter.on("criticalError", handleCritical);
        EventsEmitter.on("dataUpdate", dataUpdate);
        EventsEmitter.on("changeTab", changeTab);
        EventsEmitter.on("cacheUpdate", cacheUpdate);
        EventsEmitter.on("reloadData", reloadData);
        return () => {
            EventsEmitter.removeEventListener("showMessage", handleMessage);
            EventsEmitter.removeEventListener("criticalError", handleCritical);
            EventsEmitter.removeEventListener("dataUpdate", dataUpdate);
            EventsEmitter.removeEventListener("changeTab", changeTab);
            EventsEmitter.removeEventListener("cacheUpdate", cacheUpdate);
            EventsEmitter.removeEventListener("reloadData", reloadData);
        };
    }, []);

    useEffect(() => {
        if (SignalrService.status !== SignalrStatus.CONNECTED) {
            SignalrService.start();
        }
    }, []);

    const menus: MenuItems = getMenus('en-US');

    return (
        <div style={{ width: "100%", height: "100vh" }}>
            
            <AppContext.Provider value={AppContextValue}>
                <JumboLayoutProvider layoutConfig={defaultLayoutConfig}>
                    <JumboLayout
                        header={<Header />}
                        // @ts-ignore
                        //footer={<Footer lang='en-US' />}
                        sidebar={<Sidebar menus={menus} />}
                    >
                        <SnackbarProvider
                            maxSnack={5}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right'
                            }}
                            classes={{
                                containerRoot: 'bottom-0 right-0 mb-52 md:mb-68 mr-8 z-9999'
                            }}
                        >
                            <JumboDialogProvider>
                                <Main component={error["redirect"] ? <ErrorMessage message={error["message"]} /> : ""} />
                                {notification["message"] !== "" ? (
                                    <AlertDialog handleClose={handleCloseAlert} notification={notification} />
                                ) : (
                                    ""
                                )}
                                <NotificationPanel />
                                <JumboDialog />
                            </JumboDialogProvider>
                            <Joyride
                                callback={handleCallback}
                                beaconComponent={BeaconComponent}
                                continuous
                                run={runTour}
                                stepIndex={stepIndex}
                                steps={tourSteps}
                                showSkipButton
                                //showProgress={true}
                                styles={{
                                    options: {
                                        arrowColor: "#26324D",
                                        backgroundColor: "#26324D",
                                        primaryColor: "#3DABE6",
                                        textColor: "#fff",
                                        zIndex: 999999
                                    },
                                    tooltip: {
                                        borderRadius: "15px"
                                    }
                                }}
                            />
				            {/* <AppTourNotification /> */}
                        </SnackbarProvider>
                    </JumboLayout>
                </JumboLayoutProvider>
            </AppContext.Provider>
        </div>
    );
}
